export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/electrical-f87279cb9046dcb446d1db73422c998f.svg";